/* eslint-disable react/jsx-props-no-spreading */
import type { ReactNode, VoidFunctionComponent } from 'react';

import useLicense from '../../../hooks/api/licenses/useLicense';
import useRevisionLicense from '../../../hooks/api/licenses/useRevisionLicense';

import LicenseContent from './LicenseContent';
import type { DependencyProp } from './types';

type GlobalScopeProps = {
  scope: 'global';
  licenseId: string;
  /**
   * Optional buttons to display in the drawer.
   */
  buttons?: ReactNode[];
};

type DependencyScopeProps = {
  scope: 'dependency';
  dependency: DependencyProp;
  revisionLicenseId: number;
};

type Props = GlobalScopeProps | DependencyScopeProps;

function isDependencyScopeProps(props: Props): props is DependencyScopeProps {
  return props.scope === 'dependency';
}

const GlobalScopeLicenseDrawer: VoidFunctionComponent<GlobalScopeProps> = (props) => {
  const { data, isLoading } = useLicense(props.licenseId);

  return <LicenseContent {...props} license={data} isLoading={isLoading} />;
};

const DependencyScopeLicenseDrawer: VoidFunctionComponent<DependencyScopeProps> = (props) => {
  const { data, isLoading } = useRevisionLicense(props.dependency.locator, props.revisionLicenseId);

  return <LicenseContent {...props} license={data} isLoading={isLoading} />;
};

const LicenseDrawerContainer: VoidFunctionComponent<Props> = (props) => {
  if (isDependencyScopeProps(props)) {
    return <DependencyScopeLicenseDrawer {...props} />;
  }

  return <GlobalScopeLicenseDrawer {...props} />;
};

export default LicenseDrawerContainer;
